import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function userSessionDeleteApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/session/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	return await requester.sendRequest(payload, token)
}
